import React from 'react';
import { useLocation } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { CookieConsent } from './CookieConsent';
interface SiteLayoutProps {
  children: React.ReactNode;
}
/**
 * Checkout runs as a focused, chrome-free surface: no site nav, no footer.
 * Every other route gets the full site chrome.
 */
const BARE_ROUTES = ['/checkout'];
export function SiteLayout({
  children
}: SiteLayoutProps) {
  const location = useLocation();
  const isBare = BARE_ROUTES.includes(location.pathname);
  if (isBare) {
    return <>
        <main className="min-h-screen bg-black" data-id="element-134" data-mp="3nlw3n3xb2pzx">{children}</main>
        <CookieConsent data-id="element-135" data-mp="3nmnuy2jve1ke" />
      </>;
  }
  return <>
      <Navbar data-id="element-136" data-mp="3sl8mzeoyxexr" />
      <main data-id="element-137" data-mp="3sjnsfp2nlvzw">{children}</main>
      <Footer data-id="element-138" data-mp="3sn1surrrbv4p" />
      <CookieConsent data-id="element-139" data-mp="1eo0875y4t6j" />
    </>;
}